export default __webpack_public_path__ + "static/media/phone.b1e7dba3.svg";